export default "__VITE_ASSET__ABFLfAg2__"